import { LogoComplete } from '@/components/LogoComplete';
import StatCard from '@/components/StatCard';
import FeatureCardWithImage from '@/components/FeatureCardWithImage';
import TeamMemberCard from '@/components/TeamMemberCard';
import { ImgApp } from '@/components/ImgApp';
import FAQItem from '@/components/FAQItem';
import { useState, useEffect } from 'react';

const Standard: React.FC = () => {
    const [showWhatsApp, setShowWhatsApp] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // Procura a seção "PARA QUEM É O BANCO?" pelo ID
            const paraQuemSection = document.getElementById('para-quem-e-o-banco');
            
            if (paraQuemSection) {
                const rect = paraQuemSection.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                
                // Mostra o WhatsApp quando a seção "PARA QUEM É O BANCO?" está visível
                // (quando o topo da seção está acima de 70% da tela)
                setShowWhatsApp(rect.top < windowHeight * 0.7);
            } else {
                // Fallback: mostra após rolar 50% da altura da tela
                const scrollY = window.scrollY;
                const windowHeight = window.innerHeight;
                setShowWhatsApp(scrollY > windowHeight * 0.5);
            }
        };

        window.addEventListener('scroll', handleScroll);
        // Checa também no carregamento da página
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="">
            {/* Welcome Section */}
            <div className="text-center relative overflow-hidden p-4 md:p-16 bg-[#101728]">
                <div className='flex flex-col lg:flex-row justify-center gap-8 lg:gap-40 items-center'>
                    <div className='flex flex-col max-w-[500px] gap-4 text-center lg:text-left items-center lg:items-start'>
                        <LogoComplete />
                        <p className='font-codec text-white text-[24px] md:text-[37.8px] font-semibold leading-[1.2]'>
                            Conquiste sua aprovação na prova de residência de <span className='text-[#c1ff72]'>Medicina Veterinária</span> com nosso App, Banco de Questões e Flashcards Premium!
                        </p>
                        <p className='font-codec text-white text-[14px] md:text-[15.4px] font-light'>
                            <span className='font-normal'>São 1.000 questões comentadas </span>para quem não aceita estudar como todo mundo.
                        </p>
                        <p className='font-codec text-white text-[14px] md:text-[15.4px] font-light'>
                            501 questões de provas reais, com o tipo de pergunta que já caiu e o tipo de raciocínio que vai cair de novo. 
                        </p>
                        <p className='font-codec text-white text-[14px] md:text-[15.4px] font-light'>
                            <strong> 499 questões inéditas</strong> com comentários clínicos. Escritas por especialistas. 
                        </p>
                        <p className='font-codec text-white text-[14px] md:text-[15.4px] font-light'>
                            E mais: <strong>1.000 flashcards prontos</strong> para revisão rápida e eficaz, além da liberdade de criar seus próprios flashcards personalizados para estudar exatamente do seu jeito. 
                        </p>
                        <a href='https://teraquiz.com/asaas?id=banco-premium-teravet-2025' className='w-full max-w-[300px] text-[14px] md:text-[17.2px] p-3 mt-4 font-codec font-semibold bg-gradient-to-r from-[#5bb960] to-[#a6dd60] rounded-full text-white block text-center no-underline'>
                            QUERO MINHA APROVAÇÃO
                        </a>
                    </div>
                    <ImgApp />
                </div>
            </div>
            {/* Numbers */}
            <div className="relative overflow-hidden flex flex-col md:flex-row">
                <StatCard
                    number="501"
                    title="questões de provas reais"
                    description="com o tipo de pergunta que já caiu. Com o tipo de raciocínio que vai cair de novo"
                    backgroundColor="#5bb960"
                />
                <StatCard
                    number="499"
                    title="questões inéditas"
                    description="com comentários clínicos. Escritas por especialistas"
                    backgroundColor="#a6dd60"
                />
                <StatCard
                    number="1000"
                    title="flashcards prontos"
                    description="para revisão rápida e eficaz, organizados por tema e especialidade. E ainda crie seus próprios flashcards personalizados."
                    backgroundColor="#5bb960"
                />
            </div>
            {/* Como FUNCIONA o banco: */}
            <div className="text-left relative overflow-hidden flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-40 bg-white font-open-sauce p-4 md:p-16">
                <div className='flex flex-col items-center lg:items-start w-full lg:w-[270px] text-center lg:text-left'>
                    <p className='leading-[1.1] text-[24px] md:text-[48.4px] font-semibold'>COMO <span className='text-[#5bb960]'>FUNCIONA</span> O BANCO:</p>
                    <div className='lg:pt-2 pt-8'>
                        <p className='text-[#5bb960] lg:text-[14px] text-[18.1px] font-semibold'>Foco na sua aprovação.</p>
                        <p className='leading-[1.3] lg:text-[14px] text-[15.1px] font-light'>Estude com estratégia. Treine com questões que simulam o estilo da prova, com explicações didáticas e atualizadas.</p>
                    </div>
                </div>
                {/* Item */}
                <div className='font-open-sauce flex flex-col gap-8'>
                    <FeatureCardWithImage
                        title='Monte sua prova personalizada'
                        description={<p>Você escolhe os temas, o número de questões e o nível de dificuldade. <strong>Pratique com o que realmente cai na prova da CRMV.</strong></p>}
                        imageUrl='https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754496139805930969_68937c8b.png'
                    />
                    <FeatureCardWithImage
                        title='Otimize seu tempo'
                        description={<p>Estude quando e onde quiser, com acesso fácil pelo celular, tablet ou computador. <strong>Ideal para estudantes de Medicina Veterinária  que querem revisar com objetividade e passar de primeira.</strong></p>}
                        imageUrl='https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754496266146934426_68937d0a.png'
                    />
                    <FeatureCardWithImage
                        title='Todos os temas da prova'
                        description={<p>Doenças infecciosas/parasitárias, Epidemiologia & análise de risco, Medicina veterinária legal, Bem-estar animal, Inspeção de produtos animais...</p>}
                        imageUrl='https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754496293282698682_68937d25.png'
                    />
                    <FeatureCardWithImage
                        title='Reforce com Flashcards'
                        description={<p>Acelere sua memorização com 1000 flashcards prontos, organizados por tema e especialidade. Revise conceitos-chave de forma rápida e eficaz e crie seus próprios flashcards para personalizar seus estudos.</p>}
                        imageUrl='https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754496139805930969_68937c8b.png'
                    />
                </div>

            </div>
            <div className='mb-8 md:mb-16 font-open-sauce mx-4 md:mx-16 mt-4'>
                <div className='flex flex-col bg-gradient-to-br from-slate-800 to-black items-center text-white rounded-3xl shadow-xl border border-gray-700/50 relative overflow-hidden'>
                    {/* Simple decorative elements */}
                    <div className="absolute top-6 right-6 w-16 h-16 bg-[#5bb960]/10 rounded-full blur-lg"></div>
                    <div className="absolute bottom-6 left-6 w-12 h-12 bg-[#a6dd60]/10 rounded-full blur-lg"></div>
                    
                    {/* Header */}
                    <div className='p-8 md:p-10 w-full text-center'>
                        <h2 className='text-[28px] md:text-[48px] font-bold text-white mb-2'>
                            Se você<span className='text-[#c1ff72]'>...</span>
                        </h2>
                        <p className='text-gray-400 text-[14px] md:text-[16px] max-w-md mx-auto'>
                            Se identifica com alguma dessas situações, este banco é perfeito para você
                        </p>
                    </div>
                    
                    {/* Content */}
                    <div className='w-full max-w-4xl px-4 md:px-8 pb-24'>
                        <div className='grid md:grid-cols-1 gap-4 md:gap-6'>
                            <div className='bg-gradient-to-r from-gray-800/70 to-gray-900/70 p-6 md:p-8 rounded-2xl border border-gray-600/30 backdrop-blur-sm'>
                                <div className='flex items-center gap-4 mb-4'>
                                    <div className='w-10 h-10 bg-[#5bb960] rounded-full flex items-center justify-center flex-shrink-0'>
                                        <span className='text-white font-bold text-lg'>1</span>
                                    </div>
                                    <h3 className='text-[#c1ff72] font-semibold text-[16px] md:text-[18px]'>
                                        Não sabe por onde começar
                                    </h3>
                                </div>
                                <p className='text-gray-200 text-[14px] md:text-[16px] leading-relaxed pl-14'>
                                    Muita matéria e cada programa pede algo diferente.
                                </p>
                            </div>

                            <div className='bg-gradient-to-r from-gray-800/70 to-gray-900/70 p-6 md:p-8 rounded-2xl border border-gray-600/30 backdrop-blur-sm'>
                                <div className='flex items-center gap-4 mb-4'>
                                    <div className='w-10 h-10 bg-[#a6dd60] rounded-full flex items-center justify-center flex-shrink-0'>
                                        <span className='text-black font-bold text-lg'>2</span>
                                    </div>
                                    <h3 className='text-[#c1ff72] font-semibold text-[16px] md:text-[18px]'>
                                        Perde tempo estudando
                                    </h3>
                                </div>
                                <p className='text-gray-200 text-[14px] md:text-[16px] leading-relaxed pl-14'>
                                    Por livros enormes, sem focar no que realmente cai.
                                </p>
                            </div>

                            <div className='bg-gradient-to-r from-gray-800/70 to-gray-900/70 p-6 md:p-8 rounded-2xl border border-gray-600/30 backdrop-blur-sm'>
                                <div className='flex items-center gap-4 mb-4'>
                                    <div className='w-10 h-10 bg-[#c1ff72] rounded-full flex items-center justify-center flex-shrink-0'>
                                        <span className='text-black font-bold text-lg'>3</span>
                                    </div>
                                    <h3 className='text-[#c1ff72] font-semibold text-[16px] md:text-[18px]'>
                                        Tem ansiedade
                                    </h3>
                                </div>
                                <p className='text-gray-200 text-[14px] md:text-[16px] leading-relaxed pl-14'>
                                    Por não saber o estilo das questões e o que é mais cobrado.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* PARA QUEM É O BANCO? */}
            <div id="para-quem-e-o-banco" className='font-open-sauce flex flex-col bg-gradient-to-br from-black via-gray-900 to-black items-center text-white p-4 md:p-8 relative overflow-hidden'>
                {/* Background decorative elements */}
                <div className="absolute top-6 left-6 w-16 h-16 bg-[#5bb960]/10 rounded-full blur-lg"></div>
                <div className="absolute bottom-6 right-6 w-20 h-20 bg-[#a6dd60]/10 rounded-full blur-lg"></div>
                
                <div className='bg-gradient-to-br from-white/15 to-white/5 backdrop-blur-lg border border-white/30 rounded-[20px] md:rounded-[32px] p-4 md:p-8 lg:p-10 w-full max-w-4xl relative shadow-xl'>
                    {/* Subtle inner glow */}
                    <div className="absolute inset-0 bg-gradient-to-br from-[#5bb960]/5 to-transparent rounded-[20px] md:rounded-[32px] pointer-events-none"></div>
                    
                    <div className='flex flex-col items-center text-white gap-6 lg:gap-8 relative z-10'>
                        <div className='w-full leading-[1.1] text-center'>
                            <div className="relative">
                                <p className='text-[24px] md:text-[48px] font-bold bg-gradient-to-r from-white via-[#c1ff72] to-white bg-clip-text text-transparent mb-3'>
                                    PARA QUEM É O BANCO?
                                </p>
                                {/* Decorative line */}
                                <div className="w-12 h-1 bg-gradient-to-r from-[#5bb960] to-[#a6dd60] rounded-full mx-auto mb-4"></div>
                            </div>
                        </div>
                        
                        <div className='flex-1 max-w-full lg:max-w-[500px] flex flex-col leading-[1.4] gap-4 md:gap-6 text-center lg:text-left'>
                            {/* Profile 1 */}
                            <div className='group'>
                                <div className='bg-gradient-to-r from-[#5bb960]/20 to-[#a6dd60]/20 rounded-2xl p-6 border border-[#5bb960]/30 hover:border-[#5bb960]/50 transition-all duration-300 hover:shadow-lg hover:shadow-[#5bb960]/20'>
                                    <div className='flex items-start gap-4 mb-4'>
                                        <div className='flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#5bb960] to-[#a6dd60] rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg'>
                                            1
                                        </div>
                                        <div className='flex-1'>
                                            <h3 className='text-[16px] md:text-[19px] font-bold text-[#c1ff72] mb-3'>
                                                Recém-formados em Medicina Veterinária
                                            </h3>
                                            <ul className='space-y-2 text-[14px] md:text-[16px] font-light text-gray-200'>
                                                <li className='flex items-start gap-2'>
                                                    <div className='w-1.5 h-1.5 bg-[#5bb960] rounded-full mt-2 flex-shrink-0'></div>
                                                    <span>Querem passar de primeira na residência.</span>
                                                </li>
                                                <li className='flex items-start gap-2'>
                                                    <div className='w-1.5 h-1.5 bg-[#a6dd60] rounded-full mt-2 flex-shrink-0'></div>
                                                    <span>Geralmente estão saindo da graduação e não têm experiência prática suficiente para competir só com currículo.</span>
                                                </li>
                                                <li className='flex items-start gap-2'>
                                                    <div className='w-1.5 h-1.5 bg-[#c1ff72] rounded-full mt-2 flex-shrink-0'></div>
                                                    <span>Buscam atalhos e simulados que mostrem o padrão das provas.</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Profile 2 */}
                            <div className='group'>
                                <div className='bg-gradient-to-r from-[#a6dd60]/20 to-[#5bb960]/20 rounded-2xl p-6 border border-[#a6dd60]/30 hover:border-[#a6dd60]/50 transition-all duration-300 hover:shadow-lg hover:shadow-[#a6dd60]/20'>
                                    <div className='flex items-start gap-4 mb-4'>
                                        <div className='flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#a6dd60] to-[#5bb960] rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg'>
                                            2
                                        </div>
                                        <div className='flex-1'>
                                            <h3 className='text-[16px] md:text-[19px] font-bold text-[#c1ff72] mb-3'>
                                                Veterinários que já tentaram residência e não passaram
                                            </h3>
                                            <ul className='space-y-2 text-[14px] md:text-[16px] font-light text-gray-200'>
                                                <li className='flex items-start gap-2'>
                                                    <div className='w-1.5 h-1.5 bg-[#a6dd60] rounded-full mt-2 flex-shrink-0'></div>
                                                    <span>Já conhecem a prova e sabem que precisam de foco em questões para identificar pontos fracos.</span>
                                                </li>
                                                <li className='flex items-start gap-2'>
                                                    <div className='w-1.5 h-1.5 bg-[#5bb960] rounded-full mt-2 flex-shrink-0'></div>
                                                    <span>Querem otimizar o tempo estudando exatamente o que cai.</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Profile 3 */}
                            <div className='group'>
                                <div className='bg-gradient-to-r from-[#c1ff72]/20 to-[#5bb960]/20 rounded-2xl p-6 border border-[#c1ff72]/30 hover:border-[#c1ff72]/50 transition-all duration-300 hover:shadow-lg hover:shadow-[#c1ff72]/20'>
                                    <div className='flex items-start gap-4 mb-4'>
                                        <div className='flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#c1ff72] to-[#5bb960] rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg'>
                                            3
                                        </div>
                                        <div className='flex-1'>
                                            <h3 className='text-[16px] md:text-[19px] font-bold text-[#c1ff72] mb-3'>
                                                Veterinários que prestam concursos públicos
                                            </h3>
                                            <ul className='space-y-2 text-[14px] md:text-[16px] font-light text-gray-200'>
                                                <li className='flex items-start gap-2'>
                                                    <div className='w-1.5 h-1.5 bg-[#c1ff72] rounded-full mt-2 flex-shrink-0'></div>
                                                    <span>Precisam de conteúdo abrangente em saúde pública, clínica médica, clínica cirúrgica, zoonoses, biossegurança e legislação.</span>
                                                </li>
                                                <li className='flex items-start gap-2'>
                                                    <div className='w-1.5 h-1.5 bg-[#a6dd60] rounded-full mt-2 flex-shrink-0'></div>
                                                    <span>Querem estudar com casos clínicos realistas e bem contextualizados, indo além da decoreba.</span>
                                                </li>
                                                <li className='flex items-start gap-2'>
                                                    <div className='w-1.5 h-1.5 bg-[#5bb960] rounded-full mt-2 flex-shrink-0'></div>
                                                    <span>Procuram questões atualizadas.</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/* Call to Action Button */}
                        <div className='w-full flex justify-center mt-6'>
                            <a href='https://teraquiz.com/asaas?id=banco-premium-teravet-2025' 
                               className='w-full max-w-[350px] text-[16px] md:text-[18px] p-4 md:p-5 font-codec font-semibold bg-gradient-to-r from-[#5bb960] to-[#a6dd60] rounded-full text-white text-center no-underline hover:scale-105 hover:shadow-xl transition-all duration-300 shadow-lg'>
                                QUERO MINHA APROVAÇÃO
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {/* NOSSA EQUIPE */}
            <div className='font-open-sauce flex flex-col bg-[#5bb960] items-center text-white p-4 md:p-16 gap-4'>
                <p className='pb-4 text-white text-[24px] md:text-[60.6px] font-semibold text-center'>NOSSA EQUIPE</p>
                <TeamMemberCard
                    name="Weslanne Helen Diniz Menezes"
                    registration="CRMV 454 RR"
                    description="Bacharel em Medicina Veterinária - UFRR, Especialista em Ensino e Gestão em Saúde - IFRR, Mestre em Saúde e Biodiversidade - UFRR"
                    imageUrl="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754609412479117713_68953704.jpg"
                />
                <TeamMemberCard
                    name="Cristiane Cavalheri Galdeano"
                    registration=""
                    description="Bacharel em Medicina Veterinária - IFAM Bacharel em Administração - UNL"
                    imageUrl="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754495610846248668_68937a7a.webp"
                />
                <TeamMemberCard
                    name="Yamna Lacet Zendim"
                    registration="CRMV-SP 69006"
                    description="Bacharel em Medicina Veterinária - IFAM Pós-graduanda em Dermatologia Veterinária - UFAPE"
                    imageUrl="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754495630293198927_68937a8e.webp"
                />
            </div>
            {/* COM NOSSO APP */}
            <div className='flex flex-col font-open-sauce relative overflow-hidden p-4 md:p-12 bg-gradient-to-br from-[#101728] via-[#1a2142] to-[#101728] items-center'>
                {/* Background decorative elements */}
                <div className="absolute top-8 left-8 w-20 h-20 bg-[#5bb960]/10 rounded-full blur-xl"></div>
                <div className="absolute bottom-8 right-8 w-16 h-16 bg-[#a6dd60]/10 rounded-full blur-xl"></div>
                <div className="absolute top-1/2 right-1/4 w-12 h-12 bg-[#c1ff72]/10 rounded-full blur-lg"></div>
                
                {/* Header Section */}
                <div className="text-center mb-8 md:mb-12 relative z-10">
                    <div className="w-20 h-1 bg-gradient-to-r from-transparent via-[#c1ff72] to-transparent rounded-full mx-auto mb-6"></div>
                    <h2 className='text-white text-[28px] md:text-[42px] lg:text-[52px] leading-[1.1] font-bold mb-4'>
                        COM NOSSO APP,<br />
                        <span className='bg-gradient-to-r from-[#c1ff72] to-[#a6dd60] bg-clip-text text-transparent'>
                            VOCÊ TEM:
                        </span>
                    </h2>
                    <p className='text-gray-300 text-[16px] md:text-[18px] max-w-2xl mx-auto'>
                        Uma plataforma completa para sua aprovação na residência veterinária
                    </p>
                </div>

                {/* Content Section */}
                <div className="flex flex-col lg:flex-row justify-center items-center gap-8 lg:gap-16 w-full max-w-7xl mb-8 md:mb-12 relative z-10">
                    {/* Features List */}
                    <div className='flex flex-col gap-4 md:gap-6 max-w-[500px] order-2 lg:order-1'>
                        <div className='bg-gradient-to-r from-white/10 to-white/5 backdrop-blur-lg border border-white/20 rounded-2xl p-5 md:p-6 hover:border-[#5bb960]/50 transition-all duration-300'>
                            <div className='flex items-start gap-4'>
                                <div className='w-10 h-10 bg-gradient-to-br from-[#5bb960] to-[#a6dd60] rounded-full flex items-center justify-center flex-shrink-0'>
                                    <span className='text-white font-bold'>✓</span>
                                </div>
                                <div>
                                    <h3 className='text-[#c1ff72] font-semibold text-[16px] md:text-[18px] mb-2'>
                                       Questões Personalizadas
                                    </h3>
                                    <p className='text-gray-200 text-[14px] md:text-[16px] leading-relaxed'>
                                        Monte provas sob medida com os temas e dificuldade que você precisa
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='bg-gradient-to-r from-white/10 to-white/5 backdrop-blur-lg border border-white/20 rounded-2xl p-5 md:p-6 hover:border-[#a6dd60]/50 transition-all duration-300'>
                            <div className='flex items-start gap-4'>
                                <div className='w-10 h-10 bg-gradient-to-br from-[#a6dd60] to-[#c1ff72] rounded-full flex items-center justify-center flex-shrink-0'>
                                    <span className='text-black font-bold'>✓</span>
                                </div>
                                <div>
                                    <h3 className='text-[#c1ff72] font-semibold text-[16px] md:text-[18px] mb-2'>
                                       Acesso Total por 12 meses
                                    </h3>
                                    <p className='text-gray-200 text-[14px] md:text-[16px] leading-relaxed'>
                                        Estude quando quiser, onde quiser, no celular, tablet ou computador
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='bg-gradient-to-r from-white/10 to-white/5 backdrop-blur-lg border border-white/20 rounded-2xl p-5 md:p-6 hover:border-[#c1ff72]/50 transition-all duration-300'>
                            <div className='flex items-start gap-4'>
                                <div className='w-10 h-10 bg-gradient-to-br from-[#c1ff72] to-[#5bb960] rounded-full flex items-center justify-center flex-shrink-0'>
                                    <span className='text-black font-bold'>✓</span>
                                </div>
                                <div>
                                    <h3 className='text-[#c1ff72] font-semibold text-[16px] md:text-[18px] mb-2'>
                                       Comentários Detalhados
                                    </h3>
                                    <p className='text-gray-200 text-[14px] md:text-[16px] leading-relaxed'>
                                        Explicações clínicas completas para cada questão, escritas por especialistas
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='bg-gradient-to-r from-white/10 to-white/5 backdrop-blur-lg border border-white/20 rounded-2xl p-5 md:p-6 hover:border-[#c1ff72]/50 transition-all duration-300'>
                            <div className='flex items-start gap-4'>
                                <div className='w-10 h-10 bg-gradient-to-br from-[#c1ff72] to-[#5bb960] rounded-full flex items-center justify-center flex-shrink-0'>
                                    <span className='text-black font-bold'>✓</span>
                                </div>
                                <div>
                                    <h3 className='text-[#c1ff72] font-semibold text-[16px] md:text-[18px] mb-2'>
                                       Flashcards Prontos e Personalizáveis
                                    </h3>
                                    <p className='text-gray-200 text-[14px] md:text-[16px] leading-relaxed'>
                                        Revise conceitos-chave com 1000 flashcards prontos e crie seus próprios baralhos para reforçar o aprendizado
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* App Image */}
                    <div className='flex justify-center flex-shrink-0 order-1 lg:order-2'>
                        <ImgApp showFloatingBoxes={true} />
                    </div>
                </div>
                
                {/* Bottom Card */}
                <div className='w-full max-w-4xl bg-gradient-to-r from-white via-gray-50 to-white border-2 border-[#5bb960] rounded-3xl p-6 md:p-10 shadow-2xl relative z-10'>
                    <div className="text-center">
                        <h3 className='text-[20px] md:text-[24px] font-bold text-gray-800 mb-4'>
                            🎯 Por que nosso banco é diferente?
                        </h3>
                        <p className='text-[16px] md:text-[18px] lg:text-[20px] text-gray-700 leading-relaxed'>
                            <strong className='text-[#5bb960]'>Não é um banco genérico.</strong> É um material criado por quem realmente passou pela prova, com foco no jeito que a banca cobra, na interpretação clínica, nos padrões de pegadinha e na inteligência de revisão acelerada.
                        </p>
                        <div className="mt-6 p-4 bg-[#5bb960]/10 rounded-2xl border border-[#5bb960]/20">
                            <p className='text-[16px] md:text-[18px] text-[#5bb960] font-semibold'>
                                💰 Além disso, é mais barato do que perder um ano tentando de novo.
                            </p>
                        </div>
                    </div>
                </div>
                
                {/* CTA Button */}
                <div className='mt-8 md:mt-10 relative z-10'>
                    <a href='https://teraquiz.com/asaas?id=banco-premium-teravet-2025' 
                       className='inline-block text-[16px] md:text-[18px] px-8 md:px-12 py-4 md:py-5 font-codec font-semibold bg-gradient-to-r from-[#5bb960] to-[#a6dd60] rounded-full text-white text-center no-underline hover:scale-105 hover:shadow-2xl transition-all duration-300 shadow-xl'>
                        GARANTIR MINHA VAGA AGORA
                    </a>
                </div>
            </div>
            {/* DÚVIDAS E RESPOSTAS */}
            <div className='bg-white flex flex-col lg:flex-row font-open-sauce p-4 md:p-16 gap-8 lg:gap-28 items-center justify-center'>
                <div className='flex flex-col'>
                    <div className='flex flex-col max-w-[400px]'>
                        <p className='leading-[1.1] font-semibold text-[#5bb960] text-[24px] md:text-[32px] lg:text-[47px] text-center lg:text-left'>
                            DÚVIDAS E RESPOSTAS
                        </p>
                    </div>
                    <div className='flex-1 max-w-[400px]'>
                        <FAQItem
                            question="Como funciona a prova personalizada?"
                            answer={<p>Nossa plataforma permite que você monte provas simuladas sob medida:<br /><br />Escolha as áreas de Veterinária que quer treinar (clínica, cirurgia, zootecnia, inspeção, etc.)<br /><br />Defina o número de questões e o nível de dificuldade.<br /><br />Receba uma prova no estilo das residências, com correção automática e comentários explicativos</p>}
                        />

                        <FAQItem
                            question="Como terei acesso ao conteúdo?"
                            answer={<p>Após a compra, você recebe login e senha exclusivos para acessar o nosso app e plataforma online.<br /><br />Funciona no celular, tablet ou computador.<br /><br />Sem precisar baixar nada: estude onde e quando quiser.</p>}
                        />

                        <FAQItem
                            question="Por quanto tempo terei acesso?"
                            answer={<p>Você terá acesso por 12 meses completos para treinar quantas vezes quiser.<br /><br />Durante esse período, todas as atualizações e novas questões já ficam liberadas para você.</p>}
                        />

                        <FAQItem
                            question="Tem garantia?"
                            answer={<p>Sim! Você tem 7 dias de garantia.<br /><br />Se não gostar do conteúdo ou achar que não te ajuda, devolvemos 100% do valor sem burocracia.</p>}
                        />

                        <FAQItem
                            question="É indicado para quem ainda está na graduação?"
                            answer={<p>Sim! O banco de questões foi pensado para veterinários(as) recém-formados(as), mas graduandos(as) também podem usar para:<br /><br />Se preparar com antecedência.<br /><br />Treinar para provas de residência ou concursos<br /><br />Fixar melhor os conteúdos da faculdade</p>}
                        />
                    </div>
                </div>

                {/* Imagens responsivas */}
                <div className='flex flex-col items-center justify-center gap-2'>
                    <div className='flex flex-row gap-2'>
                        <div className='h-[120px] w-[120px] md:h-[160px] md:w-[160px] lg:h-[180px] lg:w-[180px]' />
                        <img className='h-[120px] w-[120px] md:h-[160px] md:w-[160px] lg:h-[180px] lg:w-[180px] rounded-[16px] md:rounded-[24px]' src='https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754511261595524499_6893b79d.webp' />
                    </div>
                    <div className='flex flex-row gap-2'>
                        <img className='h-[120px] md:h-[160px] lg:h-[180px] rounded-[16px] md:rounded-[24px]' src='https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754511314832627292_6893b7d2.webp' />
                        <img className='h-[120px] md:h-[160px] lg:h-[180px] rounded-[16px] md:rounded-[24px]' src='https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754511298922931825_6893b7c2.webp' />
                    </div>
                </div>
            </div>
            
            {/* FOOTER */}
            <footer className='bg-gradient-to-br from-[#101728] via-[#1a2142] to-black text-white font-open-sauce'>
                {/* Final CTA Section */}
                <div className='bg-gradient-to-r from-[#5bb960] to-[#a6dd60] py-8 md:py-12 px-4 md:px-8'>
                    <div className='max-w-4xl mx-auto text-center'>
                        <h3 className='text-[24px] md:text-[32px] font-bold text-white mb-4'>
                            🎯 Não deixe sua aprovação para depois!
                        </h3>
                        <p className='text-white/90 text-[16px] md:text-[18px] mb-6 max-w-2xl mx-auto'>
                            Milhares de veterinários já conquistaram sua vaga na residência com nosso método. 
                            Seja o próximo a realizar seu sonho profissional.
                        </p>
                        <a href='https://teraquiz.com/asaas?id=banco-premium-teravet-2025' 
                           className='inline-block text-[16px] md:text-[20px] px-10 md:px-16 py-4 md:py-6 font-codec font-bold bg-white text-[#5bb960] rounded-full hover:bg-gray-100 hover:scale-105 transition-all duration-300 shadow-2xl'>
                            COMEÇAR AGORA - GARANTIR VAGA
                        </a>
                        <p className='text-white/80 text-[12px] md:text-[14px] mt-4'>
                            ✅ Garantia de 7 dias | ✅ Acesso imediato | ✅ Suporte especializado
                        </p>
                    </div>
                </div>
                
                {/* Footer Content */}
                <div className='py-8 md:py-12 px-4 md:px-8'>
                    <div className='max-w-6xl mx-auto'>
                        <div className='grid md:grid-cols-3 gap-8 md:gap-12'>
                            {/* Company Info */}
                            <div className='text-center md:text-left'>
                                <div className='mb-4'>
                                    <LogoComplete />
                                </div>
                                <p className='text-gray-300 text-[14px] md:text-[16px] mb-4 leading-relaxed'>
                                    A plataforma de questões mais completa para residência veterinária. 
                                    Criada por especialistas, aprovada por milhares de estudantes.
                                </p>
                            </div>
                            
                            {/* App Downloads & Social */}
                            <div className='text-center md:text-left'>
                                <h4 className='text-[18px] md:text-[20px] font-bold text-[#c1ff72] mb-4'>
                                    Baixe Nosso App
                                </h4>
                                <div className='flex flex-col gap-4 mb-6'>
                                    <a href='https://play.google.com/store/apps/details?id=com.hokup.radioteraquiz&pli=1' target='_blank' rel='noopener noreferrer' className='block hover:scale-105 transition-transform duration-300'>
                                        <img src='https://teraquiz.com.br/wp-content/uploads/2023/11/bt-google-play.svg' 
                                             alt='Baixar na Google Play' 
                                             className='w-full max-w-[160px] h-auto mx-auto md:mx-0' />
                                    </a>
                                    
                                    <a href='https://apps.apple.com/br/app/teraquiz/id1603222290' target='_blank' rel='noopener noreferrer' className='block hover:scale-105 transition-transform duration-300'>
                                        <img src='https://teraquiz.com.br/wp-content/uploads/2023/11/bt-app-store.svg' 
                                             alt='Baixar na App Store' 
                                             className='w-full max-w-[160px] h-auto mx-auto md:mx-0' />
                                    </a>
                                </div>
                                
                                <div className='text-center md:text-left'>
                                    <h5 className='text-[16px] font-semibold text-[#c1ff72] mb-3'>Siga-nos</h5>
                                    <a href='https://www.instagram.com/tera.vete/?igsh=OHNjdzlka3dnZjRu&utm_source=qr' target='_blank' rel='noopener noreferrer' className='inline-flex items-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-xl p-3 transition-all duration-300 hover:scale-105'>
                                        <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                                        </svg>
                                        <span className='text-white font-medium text-sm'>Instagram</span>
                                    </a>
                                </div>
                            </div>
                            
                            {/* Guarantee */}
                            <div className='text-center md:text-left'>
                                <h4 className='text-[18px] md:text-[20px] font-bold text-[#c1ff72] mb-4'>
                                    Nossa Garantia
                                </h4>
                                <div className='bg-gradient-to-r from-[#5bb960]/20 to-[#a6dd60]/20 rounded-2xl p-4 border border-[#5bb960]/30'>
                                    <div className='flex items-center justify-center md:justify-start gap-3 mb-3'>
                                        <div className='w-10 h-10 bg-[#5bb960] rounded-full flex items-center justify-center'>
                                            <span className='text-white font-bold'>7</span>
                                        </div>
                                        <span className='text-[16px] font-semibold'>dias de garantia</span>
                                    </div>
                                    <p className='text-gray-300 text-[14px] leading-relaxed'>
                                        Experimente sem riscos. Se não ficar satisfeito, devolvemos 100% do seu dinheiro.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Bottom Bar */}
                <div className='border-t border-white/10 py-4 md:py-6 px-4 md:px-8'>
                    <div className='max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4'>
                        <p className='text-gray-400 text-[12px] md:text-[14px] text-center md:text-left'>
                            © 2025 TeraQuiz Premium. Todos os direitos reservados.
                        </p>
                    </div>
                </div>
            </footer>

            {/* WhatsApp Float Button */}
            <div 
                className={`fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 transition-all duration-500 ${
                    showWhatsApp ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-4 scale-95 pointer-events-none'
                }`}
            >
                <a 
                    href="https://wa.me/5531996102844"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block hover:scale-110 transition-transform duration-300 drop-shadow-2xl"
                >
                    <div className="relative">
                        <img 
                            src="https://teraquiz.s3.us-east-005.backblazeb2.com/teraquiz/image_1754574120073778194_6894ad28.png"
                            alt="Fale conosco no WhatsApp"
                            className="w-14 h-14 md:w-16 md:h-16 object-contain shadow-2xl hover:shadow-green-500/25 transition-shadow duration-300"
                        />
                        {/* Pulse animation */}
                        <div className="absolute inset-0 w-14 h-14 md:w-16 md:h-16 bg-green-500/30 rounded-full animate-ping"></div>
                    </div>
                </a>
            </div>
        </div>
    );
};

export default Standard;